import React, { useEffect, useState } from "react";
import {
  Card,
  Flex,
  Heading,
  Td,
  Tr,
} from "@chakra-ui/react";
import TableView from "../../components/TableView";
import CustomButton from "../../components/ButtonComp";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/utils";
import { toast } from "react-toastify";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const ListBlkLpg = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(10);
  const [initialValue, setInitialValue] = useState(1);

  const fetchList = async (currentPage, currentRows) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "list");
      formData.append("page", currentPage);
      formData.append("limit", currentRows);

      const response = await fetch(baseUrl + "bulklpg.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result?.success) {
        setData(result.data || []);
        setTotalCount(result.totalcount || 0);
      } else {
        toast.error(result?.message || "Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching blk lpg list:", error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList(page, rows);
  }, [page, rows]);

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        flexDirection={["column", "row"]}
        alignItems={["stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl">Bulk LPG</Heading>
        <Flex
          direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap"
        >
          <CustomButton
            title="Add Bulk LPG"
            onClick={() => navigate("/blk-lpg/add-blk-lpg")}
            w={["100%", "auto"]}
          />
        </Flex>
      </Card>

      <div>
        {loading ? (
          <GasCylinderLoader size="sm" loadingText="Loading Bulk LPG" />
        ) : (
          <TableView
            headData={["S.No.", "Company Name", "Price"]}
            body={data.map((el, i) => (
              <Tr key={el.id}>
                <Td textAlign="center">{i + initialValue}</Td>
                <Td textAlign="center">{el.company_name}</Td>
                <Td textAlign="center">₹{el.price}</Td>
              </Tr>
            ))}
            initialValue={initialValue}
            page={page}
            rows={rows}
            total_value={totalCount}
            pagination
            onChange={(e) => {
              const newRows = parseInt(e.target.value);
              setInitialValue(1);
              setPage(1);
              setRows(newRows);
              fetchList(1, newRows);
            }}
            onPrevious={() => {
              if (page > 1) {
                const newPage = page - 1;
                setInitialValue((newPage - 1) * rows + 1);
                setPage(newPage);
              }
            }}
            onNext={() => {
              if (rows * page < totalCount) {
                const newPage = page + 1;
                setInitialValue((newPage - 1) * rows + 1);
                setPage(newPage);
              }
            }}
          />
        )}
      </div>
    </>
  );
};

export default ListBlkLpg;
